import React, { useEffect, useState, useRef } from 'react'
import { Children } from 'react'
import { connect } from 'react-redux'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Slider from 'react-slick'

const mapStateToProps = (state) => {
    return {
        uiDeviceType: state.ui.deviceType
    }
}
const defaultSlidesToShow = 3.5

const RelatedSlider = ({ classes, title, children, uiDeviceType, slidesToShowOverride }) => {
    const [slidesToShow, setSlidesToShow] = useState(defaultSlidesToShow)
    const [showArrows, setShowArrows] = useState(false)
    const [disabledArrow, setDisabledArrow] = useState('left')
    const [activeSlide, setActiveSlide] = useState(0)
    const count = Children.count(children)
    let sliderRef = useRef(null)
    useEffect(() => {
        let dynamicSlidesToShow = slidesToShowOverride?.default || defaultSlidesToShow
        if (uiDeviceType === 'mobile') {
            dynamicSlidesToShow = slidesToShowOverride?.mobile || 1.25
        } else if (uiDeviceType === 'tablet') {
            dynamicSlidesToShow = slidesToShowOverride?.tablet || 1.25
        } else if (uiDeviceType === 'intermediate') {
            dynamicSlidesToShow = slidesToShowOverride?.intermediate || 1.75
        } else if (uiDeviceType === 'laptop') {
            dynamicSlidesToShow = slidesToShowOverride?.laptop || 2.5
        } else if (uiDeviceType === 'desktop') {
            dynamicSlidesToShow = slidesToShowOverride?.desktop || 3.5
        }
        if (count <= dynamicSlidesToShow) {
            setShowArrows(false)
        } else {
            setShowArrows(true)
        }
        if (slidesToShow !== dynamicSlidesToShow) {
            setSlidesToShow(dynamicSlidesToShow)
        }
    }, [uiDeviceType])

    const onClickArrow = (direction) => {
        // NOTE: We need to do this as slider lets you click forever
        if (direction === 'left') {
            if (activeSlide > 0) {
                sliderRef.slickPrev()
            }
        } else if (activeSlide + slidesToShow < count) {
            sliderRef.slickNext()
        }
    }

    const updateSlider = (current) => {
        setActiveSlide(current)
        if (current === 0) {
            setDisabledArrow('left')
        } else if (current + slidesToShow === count) {
            setDisabledArrow('right')
        } else if (disabledArrow !== '') {
            setDisabledArrow('')
        }
    }

    let settings = {
        infinite: false,
        slidesToShow: slidesToShow,
        arrows: false,
        swipeToSlide: true,
        afterChange: current => {
            return updateSlider(current)
        }
    }

    return (
        <div className={`container related-slider ${classes} ${showArrows ? 'show-arrows' : 'no-arrows'}`}>
            <div className="related-slider-header">
                {title &&
                    <h2>
                        { title }
                    </h2>
                }
                { showArrows &&
                    <div className="related-slider-controls">
                        <span className={`control-icon left ${disabledArrow === 'left' ? 'disabled' : ''}`} onClick={() => onClickArrow('left')}>
                            <FontAwesomeIcon icon="arrow-left" />
                        </span>
                        <span className={`control-icon right ${disabledArrow === 'right' ? 'disabled' : ''}`} onClick={() => onClickArrow('right')}>
                            <FontAwesomeIcon icon="arrow-right" />
                        </span>
                    </div>
                }
            </div>
            <Slider
                ref={slider => {
                    sliderRef = slider
                }}
                {...settings}>
                { children }
            </Slider>
        </div>
    )
}

export default connect(mapStateToProps)(RelatedSlider)
